import React from "react";
import { createRoot } from "react-dom/client";
import { KatSpinner } from "@amzn/katal-react";
import { BrowserRouter as Router } from "react-router-dom";
import App from "./components/App";
import AppInitWrapper from "./components/AppInitWrapper";
import "./logger";

import "@amzn/katal-components/styles.css";
import "./index.scss";

const container = document.getElementById("root");

const renderApp = () => {
    if (container) {
        const root = createRoot(container);
        root.render(
            <React.StrictMode>
                <AppInitWrapper>
                    <React.Suspense fallback={<KatSpinner size="large" />}>
                        <Router>
                            <App />
                        </Router>
                    </React.Suspense>
                </AppInitWrapper>
            </React.StrictMode>
        );
    } else {
        console.error("Error: #root element not found.");
    }
};

if (window.loom && window.loom.loaded) {
    renderApp();
} else {
    const elem = document.getElementById('mosaic-navigation');
    if (elem) {
        const handleLoadEvent = () => {
            renderApp();
            elem.removeEventListener('mosaic.loaded', handleLoadEvent);
        };
        elem.addEventListener('mosaic.loaded', handleLoadEvent);
    } else {
        console.error("Error: #mosaic-navigation element not found.");
    }
}